import { camelCase, capitalize } from '@amperio/amperio-ui';

import { ERoutes } from '@enums';

export const getTranslationKeyAndPathForHeaderFromUrl = (pathname: string) => {
  const indexOfDashboard = pathname.indexOf(ERoutes.DASHBOARD);
  const dashboardRouteLength = ERoutes.DASHBOARD.length;

  const subdomainRoute = pathname.slice(indexOfDashboard + dashboardRouteLength + 1);
  const translationPath = subdomainRoute.replaceAll('/', '.');

  return {
    path: translationPath,
    key: camelCase(`${ERoutes.DASHBOARD}Header${capitalize(translationPath)}`),
  };
};
